import { CheckSession, Signin, GetFailedLogin, PostFailedLogin, PutFailedLogin } from './authentication';
import { GetPerson, GetPersonWithParams, PostPerson, PutPerson, DeletePerson } from './person';
import { GetPatient, GetPatientWithParams, PostPatient, PutPatient, DeletePatient } from './patient';
import { GetVisit, GetVisitWithParams, GetProcessedVisitWithParams, PostVisit, PutVisit, DeleteVisit } from './visit';
import { GetEncounter, GetEncounterWithParams, PostEncounter, PutEncounter, DeleteEncounter } from './encounter';
import { GetObs, GetObsWithParams, PostObs, PutObs, DeleteObs, PutObsString, PutObsObject } from './obs';
import { GetObsAudit, GetObsAuditWithParams, PostObsAudit, PutObsAudit, DeleteObsAudit } from './obsAudit';
import { GetImage, GetImageWithParams, PostImage, PostImageAZURE, PutImage, DeleteImage } from './image';
import { GetUser, GetUserWithParams, PostUser, PutUser, DeleteUser, PasswordUpdate } from './users';
import { GetConcept, GetConceptWithParams, PostConcept, PutConcept, DeleteConcept } from './concept';
import { GetDataType, GetDataTypeWithParams, PostDataType, PutDataType, DeleteDataType } from './datatype';
import { GetPersonType, GetPersonTypeWithParams, PostPersonType, PutPersonType, DeletePersonType } from './personType';
import { GetLocation, GetLocationWithParams, PostLocation, PutLocation, DeleteLocation } from './location';
import { GetKey, GetKeyWithParams, PostKey, PutKey, DeleteKey } from './licencekey';
import { GetProtocol, GetProtocolWithParams, PostProtocol, PutProtocol, DeleteProtocol } from './licenceKeyProtocol';
import { GetRole, GetRoleWithParams, PostRole, PutRole, DeleteRole } from './role';
import { PostPasswordEmail, PostForgotPasswordEmail } from './mail';
import { GetIpandDetails } from './ip';
import { GetHospital, GetHospitalWithParams, PostHospital, PutHospital, DeleteHospital, GetHospitalFilesWithParams, PostHospitalFile, DeleteHospitalFile } from './hospital';
import { GetEHR, GetEHRWithParams, PostEHR, PutEHR, DeleteEHR } from './ehr';
import { PostTransferBlobStorage } from './transferBlobStorage';
import { PostGithubTicket } from './github';
import { RunReportQuery, GetReportTemplates, PostReportTemplate, PutReportTemplate, DeleteReportTemplate } from './report';

export const Services = {
    Signin, CheckSession, GetFailedLogin, PostFailedLogin, PutFailedLogin,
    GetPerson, GetPersonWithParams, PostPerson, PutPerson, DeletePerson,
    GetPatient, GetPatientWithParams, PostPatient, PutPatient, DeletePatient,
    GetVisit, GetVisitWithParams, GetProcessedVisitWithParams, PostVisit, PutVisit, DeleteVisit,
    GetEncounter, GetEncounterWithParams, PostEncounter, PutEncounter, DeleteEncounter,
    GetObs, GetObsWithParams, PostObs, PutObs, DeleteObs, PutObsString, PutObsObject,
    GetObsAudit, GetObsAuditWithParams, PostObsAudit, PutObsAudit, DeleteObsAudit,
    GetImage, GetImageWithParams, PostImage, PostImageAZURE, PutImage, DeleteImage,
    GetUser, GetUserWithParams, PostUser, PutUser, DeleteUser, PasswordUpdate,
    GetConcept, GetConceptWithParams, PostConcept, PutConcept, DeleteConcept,
    GetDataType, GetDataTypeWithParams, PostDataType, PutDataType, DeleteDataType,
    GetPersonType, GetPersonTypeWithParams, PostPersonType, PutPersonType, DeletePersonType,
    GetLocation, GetLocationWithParams, PostLocation, PutLocation, DeleteLocation,
    GetKey, GetKeyWithParams, PostKey, PutKey, DeleteKey,
    GetProtocol, GetProtocolWithParams, PostProtocol, PutProtocol, DeleteProtocol,
    GetRole, GetRoleWithParams, PostRole, PutRole, DeleteRole,
    PostPasswordEmail, PostForgotPasswordEmail,
    GetIpandDetails,
    GetHospital, GetHospitalWithParams, PostHospital, PutHospital, DeleteHospital, 
    GetHospitalFilesWithParams, PostHospitalFile, DeleteHospitalFile,
    GetEHR, GetEHRWithParams, PostEHR, PutEHR, DeleteEHR,
    PostTransferBlobStorage,
    PostGithubTicket,
    RunReportQuery, GetReportTemplates, PostReportTemplate, PutReportTemplate, DeleteReportTemplate
}